import type { AuthUser, PermissionCatalogEntry } from '@/lib/types';

/** Same access logic as AppShell nav filtering. */
export function canAccessEntry(entry: PermissionCatalogEntry, user: AuthUser | null): boolean {
  if (entry.navVisible === false) return false;
  const mode = entry.access?.mode ?? 'permission';
  if (mode === 'public' || mode === 'optional' || mode === 'auth' || mode === 'operator') return true;
  const permission = entry.access?.permission;
  return Boolean(permission && user?.permissions?.includes(permission));
}
